import React from 'react';
import { connect } from 'react-redux';
import BuyOnline from "../Components/BuyOnline";

let BuyOnlineContainer = function(props) {
    return <BuyOnline {...props} />;
}

const mapStateToProps = state => {
    return {
        productResellers: state.resellerProduct.productResellers,
        productOnlineResellers: state.resellerProduct.productOnlineResellers,
        resellerCountries: state.resellerProduct.resellerCountries,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyOnlineContainer);
